import { Pipe, PipeTransform } from '@angular/core';
import { ICoordsTable } from "libraries/service/table-keyboard-navigation/table-keyboard-navigation.service";

@Pipe({
    name: 'isSameCoord'
})
export class IsSameCoordPipe implements PipeTransform {
    public transform(focusCoord: ICoordsTable, rowIndex: number, colIndex: number): boolean {
        return focusCoord && focusCoord.rowIndex === rowIndex && focusCoord.colIndex === colIndex;
    }
}